import React, { useEffect, createElement } from 'react';
import { useLocation } from 'react-router-dom';
const GA_MEASUREMENT_ID = 'G-FRN3PST59X';
declare global {
  interface Window {
    dataLayer: any[];
    gtag: (...args: any[]) => void;
  }
}
let gaInitialized = false;
const GoogleAnalytics = () => {
  const location = useLocation();
  useEffect(() => {
    if (gaInitialized) return;
    // Load the gtag.js script
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
    // Initialize dataLayer and gtag
    window.dataLayer = window.dataLayer || [];
    window.gtag = function (...args: any[]) {
      window.dataLayer.push(arguments);
    };
    window.gtag('js', new Date());
    window.gtag('config', GA_MEASUREMENT_ID);
    gaInitialized = true;
  }, []);
  // Track page views on route change
  useEffect(() => {
    if (gaInitialized && window.gtag) {
      window.gtag('config', GA_MEASUREMENT_ID, {
        page_path: location.pathname
      });
    }
  }, [location.pathname]);
  return null;
};
export default GoogleAnalytics;